export class Address {
    firstname: string;
    lastname: string;
    address: string;
    city: string;
    province :string;
    postalcode : string;
    country:string;
}
